'use client';

import { useTranslations } from 'next-intl';
// import { PackingMetrics } from './packing-metrics';
import { PackingListing } from './packing-listing';

export function PackingPageContent() {
  const t = useTranslations('packing');

  return (
    <div className='space-y-6'>
      <h1 className='text-2xl font-bold tracking-tight'>{t('pageTitle')}</h1>
      {/* <PackingMetrics /> */}
      <PackingListing />
    </div>
  );
}
